"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _filter = _interopRequireDefault(require("lodash/filter"));

var _map = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------

/** pushObjectIntoShoppingCart */


var pushObjectIntoShoppingCart = function pushObjectIntoShoppingCart(defaultState, previousState, payload) {
  var thatTotalPriceOfObjects = previousState.shoppingCartState.totalPriceOfObjects;
  var thatListOfObjects = previousState.shoppingCartState.objectsList;
  var thisCountsOfObjects = previousState.shoppingCartState.objectsCounts;
  var objectExists = (0, _filter["default"])(thatListOfObjects, {
    routeSlug: payload.routeSlug
  });
  var objectExistsLen = Object.keys(objectExists).length;
  var thisListOfObjects = thatListOfObjects;
  var thisTotalCountOfObjects = previousState.shoppingCartState.totalCountOfObjects + 1;
  var thisTotalPrice = []; // It exists from before

  if (objectExistsLen === 1) {
    thisCountsOfObjects[payload.routeSlug] += 1;
  } else {
    thisCountsOfObjects[payload.routeSlug] = 1;
    thisListOfObjects.push(payload);
  }

  (0, _map["default"])(previousState.shoppingCartState.objectsList, function (object) {
    return thisTotalPrice.push(object.price * thisCountsOfObjects[object.routeSlug]);
  });
  var thisTotalPriceOfObjects = thisTotalPrice.reduce(function (a, b) {
    return a + b;
  }, 0);
  return Object.assign({}, previousState, {
    shoppingCartState: {
      objectsList: thisListOfObjects,
      objectsCounts: thisCountsOfObjects,
      totalCountOfObjects: thisTotalCountOfObjects,
      totalPriceOfObjects: thisTotalPriceOfObjects,
      thatTotalPriceOfObjects: thatTotalPriceOfObjects,
      thisTotalPriceOfObjects: thisTotalPriceOfObjects
    }
  });
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = pushObjectIntoShoppingCart;
exports["default"] = _default;
module.exports = exports.default;